import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GetAllProduct } from '../../../redux/admin/product/product_services_syn';
import { updateProductSkip } from '../../../redux/admin/product/product_slices';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import moment from 'moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import EmptyComponent from '../../../component/EmptyComponent';
import {
  UserGetAllProduct,
  UserSearchForProductsByTitle,
} from '../../../redux/user/product/user_product_services_syn';
import { useDebouncedCallback } from 'use-debounce';

const User_Product = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [searchProduct, setSearchProduct] = useState('');

  const {
    productSkip,
    productLimit,
    completeProduct,
    product_loader,
    editProductId,
    userCompleteProductSearch,
  } = useSelector((state) => state.user_product);

  useEffect(() => {
    dispatch(
      UserGetAllProduct({
        page: productSkip,
        limit: productLimit,
      })
    );

    return () => {
      dispatch(updateProductSkip(0));

      // dispatch(updateProductLimit(10));
    };
  }, []);

  const handlePageChange = (page) => {
    dispatch(
      GetAllProduct({
        page: page,
        limit: productLimit,
      })
    );
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          UserSearchForProductsByTitle({
            title: value,
            page: 0,
            limit: productLimit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchProduct(value);

    if (value) {
      debounced(value);
    }
  };

  return (
    <>
      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchProduct || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center gap-1">
              <h4 class="card-title flex-grow-1">All Product List</h4>

              {/* <NavLink to="/dashboard/create_product">
                <a class="btn btn-sm btn-primary">Add Product</a>
              </NavLink> */}
            </div>
            <div>
              {product_loader ? (
                <TableLoader
                  headerArray={[
                    'Product Name',
                    'Price',
                    'Stock',
                    'Category',
                    'Date',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4, 5, 6]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th style={{ width: '20px' }}>
                          <div class="form-check ms-1">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              class="form-check-label"
                              for="customCheck1"
                            ></label>
                          </div>
                        </th>
                        <th>Product Name & tag</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Category</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchProduct ? (
                        userCompleteProductSearch?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          userCompleteProductSearch?.docs?.map((item, key) => (
                            <>
                              {item?._id !== editProductId ? (
                                <tr key={key}>
                                  <td>
                                    <div class="form-check ms-1">
                                      <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="customCheck2"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="customCheck2"
                                      >
                                        &nbsp;
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                        <img
                                          src={item?.gallery[0]?.pic_url}
                                          alt=""
                                          class="avatar-md"
                                        />
                                      </div>
                                      <div>
                                        <a
                                          href="#!"
                                          class="text-dark fw-medium fs-15"
                                        >
                                          {item?.product_name}
                                        </a>
                                        <p class="text-muted mb-0 mt-1 fs-13">
                                          {item?.tags}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <CurrencyFormatter
                                      value={item?.price}
                                      currency={item?.symbol}
                                    />
                                  </td>
                                  <td>
                                    <p class="mb-1 text-muted">
                                      {item?.quantity}
                                    </p>
                                  </td>
                                  <td>{item?.category}</td>
                                  <td>
                                    {`${moment(item?.date).format(
                                      'dd MM YYYY'
                                    )}`}
                                  </td>
                                  <td>
                                    <div class="d-flex gap-2">
                                      <a
                                        onClick={() => {
                                          navigate(
                                            `/user_dashboard/view_product/${item?.product_name}@${item?._id}`
                                          );
                                        }}
                                        class="btn btn-light btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:eye-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <SingleTableLoader
                                  itemArray={[1, 2, 3, 4, 5, 6]}
                                />
                              )}
                            </>
                          ))
                        )
                      ) : completeProduct?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        completeProduct?.docs?.map((item, key) => (
                          <>
                            {item?._id !== editProductId ? (
                              <tr key={key}>
                                <td>
                                  <div class="form-check ms-1">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="customCheck2"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="customCheck2"
                                    >
                                      &nbsp;
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center gap-2">
                                    <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                      <img
                                        src={item?.gallery[0]?.pic_url}
                                        alt=""
                                        class="avatar-md"
                                      />
                                    </div>
                                    <div>
                                      <a
                                        href="#!"
                                        class="text-dark fw-medium fs-15"
                                      >
                                        {item?.product_name}
                                      </a>
                                      <p class="text-muted mb-0 mt-1 fs-13">
                                        {item?.tags}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <CurrencyFormatter
                                    value={item?.price}
                                    currency={item?.symbol}
                                  />
                                </td>
                                <td>
                                  <p class="mb-1 text-muted">
                                    {item?.quantity}
                                  </p>
                                </td>
                                <td>{item?.category}</td>
                                <td>
                                  {`${moment(item?.date).format('dd MM YYYY')}`}
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <a
                                      onClick={() => {
                                        navigate(
                                          `/user_dashboard/view_product/${item?.product_name}@${item?._id}`
                                        );
                                      }}
                                      class="btn btn-light btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader
                                itemArray={[1, 2, 3, 4, 5, 6]}
                              />
                            )}
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={completeProduct?.page}
                  totalItems={completeProduct?.totalDocs}
                  pageSize={productLimit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default User_Product;
